import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="ownerMansion";

export function selectMansionProjectByOwnerId(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectMansionProjectByOwnerId/${parameter}`,
    method: 'get',
  })
}

export function insert(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function deleteOwnerMansion(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/deleteOwnerMansion`,
    method: 'put',
    data:parameter
  })
}


export function deleteObj(id){
  console.log("ids",id)
  let ids = {idList:[id]}
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export default {
  selectMansionProjectByOwnerId,
  insert,
  delete:deleteObj,
  deleteOwnerMansion,
}